import { render, staticRenderFns } from "./global-modal-error.vue?vue&type=template&id=e0b1c078&scoped=true"
import script from "./global-modal-error.vue?vue&type=script&lang=ts"
export * from "./global-modal-error.vue?vue&type=script&lang=ts"
import style0 from "./global-modal-error.vue?vue&type=style&index=0&id=e0b1c078&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b1c078",
  null
  
)

export default component.exports